import CryptoJS from 'crypto-js';

/**
 * PayFast checkout signature (Custom Integration Step 2).
 * @see https://developers.payfast.co.za/docs#step_2_signature
 *
 * Uses attribute order from the PayFast docs — NOT alphabetical (API format).
 */
const PAYFAST_CHECKOUT_FIELD_ORDER = [
  'merchant_id',
  'merchant_key',
  'return_url',
  'cancel_url',
  'notify_url',
  'fica_idnumber',
  'name_first',
  'name_last',
  'email_address',
  'cell_number',
  'm_payment_id',
  'amount',
  'item_name',
  'item_description',
  'custom_int1',
  'custom_int2',
  'custom_int3',
  'custom_int4',
  'custom_int5',
  'custom_str1',
  'custom_str2',
  'custom_str3',
  'custom_str4',
  'custom_str5',
  'email_confirmation',
  'confirmation_address',
  'payment_method',
  'subscription_type',
  'billing_date',
  'recurring_amount',
  'frequency',
  'cycles',
];

/** PHP-compatible urlencode with uppercase hex and + for spaces */
export function payfastUrlEncode(value: string): string {
  return encodeURIComponent(String(value).trim())
    .replace(/%([0-9A-Fa-f]{2})/g, (_, hex) => `%${hex.toUpperCase()}`)
    .replace(/%20/g, '+');
}

export function generatePayFastSignature(
  params: Record<string, string | number | undefined | null>,
  passphrase?: string
): string {
  const filtered: Record<string, string> = {};

  Object.entries(params).forEach(([key, value]) => {
    if (key === 'signature') return;
    if (value === '' || value == null || value === undefined) return;
    filtered[key] = String(value).trim();
  });

  const orderedKeys = PAYFAST_CHECKOUT_FIELD_ORDER.filter((key) => key in filtered);
  const extraKeys = Object.keys(filtered)
    .filter((key) => !orderedKeys.includes(key))
    .sort();

  let parameterString = '';
  [...orderedKeys, ...extraKeys].forEach((key) => {
    parameterString += `${key}=${payfastUrlEncode(filtered[key])}&`;
  });

  let signatureString = parameterString.slice(0, -1);

  if (passphrase && passphrase.trim()) {
    signatureString += `&passphrase=${payfastUrlEncode(passphrase)}`;
  }

  return CryptoJS.MD5(signatureString).toString().toLowerCase();
}

export function verifyPayFastSignature(
  fields: Record<string, string>,
  passphrase?: string
): boolean {
  const { signature, ...params } = fields;
  if (!signature) return false;
  return generatePayFastSignature(params, passphrase) === signature;
}
